





















































import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceListingServices'

  vue:
    props: ['audienceListing', 'options']

    computed:
      campaign: -> @options?.campaign || {}
      creatives: -> Object.values(@campaign.creatives || {}).reduce(((arr, creative) -> arr.concat(creative)), [])
      storageRequirements: -> @creatives.reduce(((arr, creative) -> arr.concat(creative.activation_snapshot?.storage_requirement || [])), [])
      storageFacilitiesAvailable: -> @audienceListing.storage_facilities_available || []

      shippingCheckboxes: ->
        { accepts_pallets, max_pallet_count } = @audienceListing
        text = "Accepts max #{max_pallet_count} pallets" if accepts_pallets and max_pallet_count
        text ||= "Accepts Pallets"

        [
          {
            text,
            iconClass: 'fal fa-pallet-alt'
            eventHas: accepts_pallets
          }
        ]

      storageCheckboxes: ->
        [
          {
            text: 'Storage Area'
            iconClass: 'fal fa-boxes-alt'
            campaignRequires: 'storage_available' in @storageRequirements
            eventHas: 'standard_storage_available' in @storageFacilitiesAvailable
          },
          {
            text: 'Climate Controlled'
            iconClass: 'fal fa-air-conditioner'
            campaignRequires: 'climate_controlled_storage_available' in @storageRequirements
            eventHas: 'climate_controlled_storage_available' in @storageFacilitiesAvailable
          },
          {
            text: 'Cold Storage'
            iconClass: 'fal fa-refrigerator'
            campaignRequires: 'cold_storage_available' in @storageRequirements
            eventHas: 'cold_storage_available' in @storageFacilitiesAvailable
          },
          {
            text: 'Frozen Storage'
            iconClass: 'fal fa-snowflake'
            campaignRequires: 'frozen_storage_available' in @storageRequirements
            eventHas: 'frozen_storage_available' in @storageFacilitiesAvailable
          }
        ]

      samplingServicesCheckboxes: ->
        { assembly, serve_cold } = @campaign.creatives?.product_sampling?[0]?.activation_snapshot?.supplier_provisions || {}

        services = []
        services.push {
          text: 'Can Assemble Items'
          iconClass: 'fal fa-box-full'
          campaignRequires: assembly?.required
          eventHas: @audienceListing.services.can_assemble_items
        } if assembly?.required

        services.push {
          text: 'Can Serve Chilled'
          iconClass: 'fal fa-temperature-frigid'
          campaignRequires: serve_cold
          eventHas: @audienceListing.services.can_serve_cold
        }
        services
      displaySamplingServicesFlag: ->
        @campaign.creatives?.product_sampling? || @audienceListing.spaces['Product Sampling']?

export default VueOptions.vue settings
